module.exports = __webpack_public_path__ + "assets/fonts/Alibaba-PuHuiTi-Bold.38edfe18.ttf";